var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input-number",
    _vm._g(
      _vm._b(
        {
          class: _vm.customClass,
          attrs: { value: _vm.value !== 0 ? _vm.value : undefined }
        },
        "el-input-number",
        _vm.$attrs,
        false
      ),
      _vm.new$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }